import { useTheme } from '@mui/material/styles';
import { CheckCircleOutline } from '@mui/icons-material';

import locales from '../../../../../../../constants/locales';
import DetailsList from '../../../../../../common/details-list';
import { formatToAmount } from '../../../../../../../constants/helpers/utils';
import { detailsValueFormatter } from '../../../../../../../utils/details';
import DetailsFactory from '../../../../../../common/details-list/detailsFactory';

import { OperationSuccess } from './interfaces';
import { enrollmentResultValueFormatter } from './dictionary';

interface Props {
  operation: OperationSuccess;
}

const SuccessOperation = ({ operation }: Props) => {
  const theme = useTheme();
  const { details, cost, customerMsisdn } = operation;

  return (
    <DetailsFactory
      header={{
        icon: { component: CheckCircleOutline, color: theme.palette.success.main },
        id: operation.id,
        date: operation.date,
        status: operation.status
      }}
      operationContent={
        <DetailsList
          items={[
            { label: locales.operation.label.providerName, value: detailsValueFormatter(details.providerName) },
            {
              label: locales.operation.label.customerMsisdn,
              value: detailsValueFormatter(customerMsisdn)
            },
            { label: locales.operation.label.cost, value: formatToAmount(cost.value) },
            {
              label: locales.operation.label.enrollmentResult,
              value: detailsValueFormatter(details.enrollmentResult, enrollmentResultValueFormatter)
            }
          ]}
        />
      }
    />
  );
};

export default SuccessOperation;
